import CommonAppbar from '../components/common/CommonAppbar';
import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import {URLS} from '../constants/appConstants';
import {useNavigate} from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {faker} from '@faker-js/faker';
import format from "date-fns/format";
import {getCoinsIcon} from '../components/common/simpleComponents';

function createData(name, coins) {
  return {name, coins};
}

const rows = [
  createData('Daily login', 1),
  createData('Watched Ads', 2),
  createData('Bought coins', 2000),
  createData('Boosted poll <poll link> for 2 hours', -100),
  createData('Boosted poll <poll link> for 10 hours', -305),
  createData('Initial', 1000),
];

export default function CoinsDashboard() {
  const navigate = useNavigate();

  const renderCoinsHistory = () => {
    return <>
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              {/*<TableCell>Date</TableCell>*/}
              <TableCell>Description</TableCell>
              <TableCell align="right">Coins</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.name}
                sx={{'&:last-child td, &:last-child th': {border: 0}}}
              >
                <TableCell component="th" scope="row">
                  {format(faker.date.recent(), 'Pp')} <br/>
                  {row.name}
                </TableCell>
                <TableCell align="right">
                  {row.coins > 0 ? <Typography variant="body1" color={'green'}>
                    + {row.coins}
                  </Typography> : <Typography variant="body1" color={'red'}>
                    {row.coins}
                  </Typography>}


                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  }

  return <>
    <CommonAppbar isMainPage={false} pageHeader={'Coins'}/>
    <Box sx={{backgroundColor: 'lightgrey', p: 1, alignItems: 'center'}}>
      <Card sx={{mb: 1}}>
        <CardContent>
          <Stack direction={'row'} justifyContent="space-between">
            <Typography variant="h6" gutterBottom>
              Balance 100 {getCoinsIcon()}
            </Typography>
            <Button variant="contained" startIcon={<AddIcon/>} onClick={() => {
              navigate(URLS.BUY_COINS)
            }}>
              Buy coins
            </Button>
          </Stack>
        </CardContent>
      </Card>

      {renderCoinsHistory()}
    </Box>
  </>
}
